export default __webpack_public_path__ + "static/media/profileimage.bcfa20e3.svg";